
import { computed, defineComponent } from "vue";
import { useRoute } from "vue-router";
import AdminMenu from "@/components/AdminMenu.vue";
import AdminHeader from "@/components/AdminHeader.vue";
import { routeNames } from "@/router";
import store from "@/stores";
import { consts } from "./services/Models";

export default defineComponent({
  name: "AppAdmin",
  components: {
    AdminMenu,
    AdminHeader,
  },
  setup() {
    const route = useRoute();
    const isTop = computed(() => route.name == routeNames.AdminLogin);
    const resource = store.useResource();
    const viewTitle = computed(() => {
      switch (route.name) {
        case routeNames.AdminContract:
        case routeNames.AdminContractCreate:
          return consts.adminContractCreateLabel;
        case routeNames.AdminMaintenance:
          return consts.adminMaintenanceLabel;
        case routeNames.AdminUsers:
          return consts.adminUsersLabel;
        case routeNames.AdminContractUsers:
        case routeNames.AdminContractUserCreate:
          return consts.adminContractUsersLabel;
      }
      return undefined;
    });

    return {
      isTop,
      viewTitle,
      ...resource,
    };
  },
});
